module.exports = __webpack_public_path__ + "img/bg_link_hoja_de_sala.1e463cb1.png";